import {
  type ParcelLabBodyItem,
  type ParcelLabResponse,
} from './ParcelLabTypes'

export const parcelLabAccessorGetParcelLabBodyItem = (
  parcelLabData: ParcelLabResponse | undefined,
  isOrderDelivered?: boolean,
): ParcelLabBodyItem | undefined => {
  if (!parcelLabData?.body) {
    return undefined
  }

  if (isOrderDelivered) {
    return parcelLabData.body[Object.keys(parcelLabData.body)[0]].find(
      (item) => item.status === 'Delivered',
    )
  }

  return parcelLabData.body[Object.keys(parcelLabData.body)[0]].find(
    (item) => item.status === 'Scheduled',
  )
}
